export default {
  WEB_NAV_HEIGHT: 48,
  FONT_SIZE_SMALL: 12,
  FONT_SIZE_REGULAR: 14,
  FONT_SIZE_HEADLINE: 16,
  FONT_SIZE_TITLE: 20,
  WHITE_COLOR: '#FFFFFF',
  BLACK_COLOR: '#000000',
  BLACK_COLOR_TRANSPARENT: 'rgba(0,0,0,0.5)',
  DARK_BLUE_COLOR: '#1D4360',
  GREY_LIGHT_COLOR: '#F2F2F2',
  GREY_LIGHTER_COLOR: '#E0E0E0',
  GREY_MEDIUM_LIGHT_COLOR: '#A7A7A7',
  GREY_MEDIUM_COLOR: '#828282',
  GREY_DARKER_COLOR: '#4F4F4F',
  GREY_DARKER_COLOR_OPACITY: '#4F4F4F40',
  GREEN_LIGHT_COLOR: '#CFF4D2',
  GREEN_DARKER_COLOR: '#329D9C',
  GREEN_WARM_COLOR: '#56C596',
  RED_ERROR_COLOR: '#D00000',
  PRIMARY_COLOR: '#329D9C',
  SECONDARY_COLOR: 'rgb(238, 167, 2)',
  FONT_WEIGHT_LIGHT: '200',
  FONT_WEIGHT_REGULAR: '400',
  FONT_WEIGHT_BOLD: '600',
  FONT_WEIGHT_HEAVY: '800',
  ICON_WIDTH: 25,
  CONTAINER_MARGIN: 20,
  BUTTON_BORDER_RADIUS: 15,
  BUTTON_BIG_BORDER_RADIUS: 30,
};
